import { ReportTemplate, ReportTemplateWatchlistMeta } from 'dashboard/models/report-template';
import { ReportTemplateVersion } from 'dashboard/models/report-template-version';
import {
  ReportTemplateActions,
  ReportTemplateActionType,
} from 'dashboard/redux/actions/report-template';

export interface ReportTemplateState {
  reportTemplate: ReportTemplate | undefined;
  latestPublishedVersion: ReportTemplateVersion | undefined;
  meta: ReportTemplateWatchlistMeta | undefined;
}

export const initialState: ReportTemplateState = {
  reportTemplate: undefined,
  latestPublishedVersion: undefined,
  meta: undefined,
};

export default function (
  state: ReportTemplateState = initialState,
  action: ReportTemplateActions,
): ReportTemplateState {
  switch (action.type) {
    case ReportTemplateActionType.ClearReportTemplate: {
      return {
        ...state,
        reportTemplate: undefined,
        latestPublishedVersion: undefined,
        meta: undefined,
      };
    }
    case ReportTemplateActionType.SetReportTemplate: {
      return {
        ...state,
        reportTemplate: action.payload.reportTemplate,
        latestPublishedVersion: action.payload.latestPublishedVersion,
        meta: action.payload.meta,
      };
    }
    default:
      return state;
  }
}
